export default () => {
  document.addEventListener("turbolinks:load", () => {
    const tabs = document.querySelectorAll('.product-tabs .product-tab-item');

    if (!tabs) {
      return;
    }

    const contents = document.querySelectorAll('.product-contents .product-content');

    tabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        console.log('DEBUG: click')

        tabs.forEach((tab) => {
          tab.classList.remove('selected')
        });

        const selectedTab = tab.className.split(' ').pop();
        tab.classList.add('selected');

        contents.forEach((content) => {
          if (content.classList.contains(selectedTab)) {
            content.classList.add('selected')
          } else {
            content.classList.remove('selected')
          }
        });
      });
    });
  });
};
